import { useMemo } from 'react'

import { Field } from 'common/fields/entities/field'
import { FilterCondition } from 'common/filter/interfaces'
import {
  FieldTypeOperator,
  FieldTypesOperators,
} from 'common/filter/models/AudienceFilter/constants'

import { ExtendedFilterCondition } from '../interfaces'

import { OPERATOR_VIEW_ALIASES } from './constants'

export const useConditionOperators = (condition: FilterCondition, fieldDesc?: Field) => {
  return useMemo(() => {
    // Hack for supporting old operators
    const processedCondition: ExtendedFilterCondition = { ...condition }
    const { operator } = processedCondition
    const isOldOperator =
      operator && (operator === FieldTypeOperator.IN || operator === FieldTypeOperator.NOT_IN)

    if (isOldOperator) {
      processedCondition.originOperator = processedCondition.operator
      processedCondition.operator = OPERATOR_VIEW_ALIASES[operator]
    }

    const operators = fieldDesc ? FieldTypesOperators[fieldDesc.type] : []
    const operatorValue = processedCondition.operator || operators?.at(0)?.value
    const operatorDesc = operators?.find(
      (op) => op.value === operatorValue || op.value === processedCondition.originOperator,
    )
    return { processedCondition, operatorDesc }
  }, [condition, fieldDesc])
}
